import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const companyGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const companyId = getCompanyId(route);

  if (companyId && companyId === authService.userInfo?.companyId?.toString()) {
    return true;
  }
  if(authService.userInfo?.companyId) {
    router.navigate(['/company', authService.userInfo?.companyId]);
  } else {
    router.navigate(['/']);
  }
  return false;
};

const getCompanyId = (route: ActivatedRouteSnapshot): string | undefined => {
  // Check current route and its children
  let current: ActivatedRouteSnapshot | null = route;
  while (current) {
    if (current.params['companyId']) return current.params['companyId'];
    if (current.firstChild?.params['companyId']) return current.firstChild.params['companyId'];
    current = current.parent;
  }

  // Fallback: extract from URL segments
  const companyIndex = route.url.findIndex((seg) => seg.path === 'company');
  return companyIndex !== -1 && companyIndex + 1 < route.url.length ? route.url[companyIndex + 1].path : undefined;
};
